import React from 'react'
import { MarketingCampaignDetailDto } from 'api/Trading-Accounts/Types/MarketingCampaignDetailDto'

import { CampaignDetailsResultsPage } from './CampaignDetailsResultsPage'
import campaignMarginBonusDetailsResultsColumn from './campaignMarginBonusDetailsResultsColumn'

interface OuterProps {
  data: MarketingCampaignDetailDto
}

export const CampaignMarginBonusDetailsResultsPage: React.FC<OuterProps> = ({ data }) => {
  return (
    <CampaignDetailsResultsPage
      data={data}
      columns={campaignMarginBonusDetailsResultsColumn}
      sortQuery={[]}
    />
  )
}
